// extracted by mini-css-extract-plugin
module.exports = {"button":"PlayPauseButton_button__O9XM7","pause":"PlayPauseButton_pause__cojFX","play":"PlayPauseButton_play__vCCKH"};